import { useState, useEffect } from 'react';
import { RedButton } from '../components/common';
import { animate } from "@genfun/core/api/API";
import animation from "../data/animate.json";
import './AnimationPopup.css';

// Default animation options
const defaultOptions = [
    { icon: "💦", text: "Cumshot", data: { action: "cumshot" } },
    { icon: "🍭", text: "Blowjob", data: { action: "blowjob" } },
    { icon: "👩🏻", text: "Rimming", data: { action: "rimming" } },
    { icon: "👩🏿‍🦱", text: "Twerking", data: { action: "twerking" } },
    { icon: "👩🏻", text: "Fisting", data: { action: "fisting" } },
    { icon: "👩🏿", text: "POV insertion", data: { action: "pov_insertion" } },
    { icon: "👩🏿‍🦱", text: "Fingering", data: { action: "fingering" } }
];

const action2options = animation.action2options;
const optionsRegistry = animation.optionsRegistry;

function CloseIcon() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M1 11L11 1" stroke="#FFB2C6" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    );
}

function getOptions(config) {
    if (!config) return null;
    if (config.type === "video") return null;
    if (config.prompt?.prompt_type !== "options") return null;

    let optionsNames = [];
    if (config.action === "solo") {
        if (action2options.hasOwnProperty(config.prompt.data?.pose)) {
            optionsNames = action2options[config.prompt.data.pose].options;
        } else {
            return null;
        }
    } else {
        if (action2options.hasOwnProperty(config.action)) {
            optionsNames = action2options[config.action].options;
        } else {
            return null;
        }
    }

    const options = [];
    for (const optionName of optionsNames) {
        if (optionsRegistry[optionName]) {
            options.push(optionsRegistry[optionName]);
        }
    }
    return options.length > 0 ? options : null;
}

function OptionButton({ option, selected, onClick }) {
    return (
        <button
            className={`animationOption ${selected ? 'animationOptionSelected' : ''}`}
            onClick={onClick}
        >
            <span className="animationOptionIcon">{option.icon}</span>
            <span className="animationOptionText">{option.text}</span>
        </button>
    );
}

export function AnimationPopup({
    isOpen,
    setIsOpen,
    token,
    taskId,
    batchIdx,
    onAnimateStart,
    onAnimateComplete,
    onAnimateError,
    onPaymentRequired,
    generationConfig
}) {
    const [selectedAction, setSelectedAction] = useState(null);
    const [dynamicOptions, setDynamicOptions] = useState(null);

    useEffect(() => {
        if (generationConfig) {
            const opts = getOptions(generationConfig);
            setDynamicOptions(opts);
        }
    }, [generationConfig]);

    // Reset selection when popup opens
    useEffect(() => {
        if (isOpen) setSelectedAction(null);
    }, [isOpen]);

    const options = dynamicOptions || defaultOptions;

    const handleAnimate = async () => {
        if (!selectedAction || !token) return;

        onAnimateStart?.();
        setIsOpen(false);

        try {
            const [response, status] = await animate(token, taskId, selectedAction, batchIdx, null);
            if (status === 402) {
                onPaymentRequired?.();
                return;
            }
            if (status !== 200) {
                onAnimateError?.("Animation failed. Please try again.");
                return;
            }
            onAnimateComplete?.(response.task_id);
        } catch (err) {
            onAnimateError?.("Failed to start animation");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="animationPopupOverlay" onClick={() => setIsOpen(false)}>
            <div className="animationPopupPanel" onClick={e => e.stopPropagation()}>
                <button className="animationPopupCloseBtn" onClick={() => setIsOpen(false)}>
                    <CloseIcon />
                </button>

                <h2 className="animationPopupTitle">Choose animation</h2>

                <div className="animationOptionsList">
                    {options.map((option, index) => (
                        <OptionButton
                            key={option.data.action}
                            option={option}
                            selected={selectedAction === option.data.action}
                            onClick={() => setSelectedAction(option.data.action)}
                        />
                    ))}
                </div>

                {selectedAction && (
                    <div className="animationPopupButtonWrapper">
                        <RedButton onClick={handleAnimate}>
                            Animate
                        </RedButton>
                    </div>
                )}
            </div>
        </div>
    );
}

export default AnimationPopup;
